import { useEffect, useRef, useState } from "react";
import "./Header.scss";
import { Container, Dropdown, Navbar } from "react-bootstrap";
import { Link, NavLink, useSearchParams } from "react-router-dom";
import logo from "../../../assets/images/logo.svg";
import lightLogo from "../../../assets/images/light-Logo.svg";
import { QRCode } from 'react-qrcode-logo';
import { DownArrowIcon, ResetLayoutIcon, SettingIcon, UnlockIcon, UserIcon } from "../../../assets/Svg/SvgImages.jsx";
import { useDispatch, useSelector } from "react-redux";
import { getUserInfo, getUserLayout, resetLayout, saveChangesGridLayout, saveChangesGridList } from "../../../features/persist/persistSlice";
import { allAssetTypeOption, assetTypeDropdownOptions, ALL_ASSET_TYPE_VALUE } from "../../../constants/assetType.constants";
import { ATS, setActivePairBalance } from "../../../features/ats/atsSlice";
import NotificationList from "./NotificationList.jsx";
import { parseJSON, toFix } from "../../../helpers/commonHelper";
import { DEFAULT_LAYOUT } from "../../../constants/grid.layout";
import { normalizeTheme } from "../../../helpers/themeHelper";
import ThemePalette from "./ThemePalette.jsx";
import UserProfileModal from "./UserProfileModal.jsx";
// import { setTheme } from '../../../features/theme/theme.slice';

const Header = () => {
  const [queryParams] = useSearchParams();
  const [isActive, setIsActive] = useState(false);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [selectedAssetType, setSelectedAssetType] = useState(allAssetTypeOption);
  const toggleClass = () => {
    setIsActive(!isActive);
  };
  const current_breakpoint = useSelector(state => state.persist.current_breakpoint);
  const layoutList = useSelector(state => state.persist.layoutList);
  const selectedPair = useSelector(state => state.ats.selectedPair);
  const selectedTradeWallet = useSelector(state => state.ats.selectedTradeWallet);
  const userInfo = useSelector(state => state?.persist?.userInfo);
  const activePairBalance = useSelector(state => state.ats.activePairBalance);
  const theme = normalizeTheme(useSelector(state => state.persist.theme));
  const dispatch = useDispatch();
  const hanldeResetLayout = () => {
    dispatch(resetLayout());
  };
  const logout = async () => {
    try {
      await dispatch(ATS.logout());
    } catch {
      /* logout thunk resolves even on API failure */
    }
  };
  const fetchAssetsByType = async assetTypeValue => {
    const response = await dispatch(ATS.fetchAssetListByType(assetTypeValue));
    console.log("get_asset_list response:", response);
  };
  const handleAssetTypeChange = option => {
    setSelectedAssetType(option);
    fetchAssetsByType(option.value);
  };
  const fetchUserInfo = async () => {
    await dispatch(getUserInfo());
  };
  const fetchPairs = async () => {
    const pair = queryParams.get("symbol");
    await dispatch(ATS.fetchPairList(pair));
  };
  useEffect(() => {
    fetchPairs();
    fetchUserInfo();
    fetchAssetsByType(ALL_ASSET_TYPE_VALUE);
  }, []);
  useEffect(() => {
    if (!selectedTradeWallet) {
      dispatch(setActivePairBalance(null));
    }
  }, [dispatch, selectedTradeWallet]);
  const ref = useRef();
  const onclick = () => {
    window.scrollTo(0, 0);
    if (ref.current && document.body.clientWidth < 11899) {
      ref.current.click();
    }
  };
  const openUserProfile = () => {
    setProfileModalOpen(true);
    dispatch(getUserInfo());
    onclick();
  };
  const onSelectSctions = async type => {
    console.log("Function Calling 1");
    const layouts = parseJSON(layoutList);
    const currentIndex = layouts.findIndex(o => o.active);
    const currentLayout = layouts[currentIndex]?.layout;
    if (!currentLayout) return;
    const defaultLg = DEFAULT_LAYOUT?.lg?.find(o => o.i === type);
    const defaultMd = DEFAULT_LAYOUT?.md?.find(o => o.i === type);
    if (!defaultLg && !defaultMd) return;
    let didChange = false;
    if (defaultLg) {
      currentLayout.lg = currentLayout.lg ?? [];
      const existsInLg = currentLayout.lg.some(o => o.i === type);
      if (!existsInLg) {
        currentLayout.lg.push(parseJSON(defaultLg));
        didChange = true;
      }
    }
    if (defaultMd) {
      currentLayout.md = currentLayout.md ?? [];
      const existsInMd = currentLayout.md.some(o => o.i === type);
      if (!existsInMd) {
        currentLayout.md.push(parseJSON(defaultMd));
        didChange = true;
      }
    }
    if (!didChange) return;
    dispatch(saveChangesGridLayout(currentLayout));
    dispatch(saveChangesGridList(layouts));
    await getUserLayout("PUT", {
      layouts
    });
  };
  return <>
      <header className={isActive ? "siteHeader openmenu" : "siteHeader"}>
        <Navbar expand="xl">
          <Container fluid className="px-0">
            <div className="brandLogo oasisBrand" aria-label="Oasis Pro Markets">
              <span className="oasisBrand__mark">
                <span className="oasisBrand__b1">OASIS PRO</span>
                <span className="oasisBrand__b2">Markets</span>
              </span>
              <img className="d-none" src={theme === "light" ? lightLogo : logo} alt="logo" />
            </div>
            <Navbar.Collapse className="justify-content-between">
              <div className="navLink d-xl-flex">
                <Link onClick={onclick} to="/" className="brandLogo oasisBrand d-block d-xl-none" aria-label="Oasis Pro Markets">
                  <span className="oasisBrand__mark">
                    <span className="oasisBrand__b1">OASIS PRO</span>
                    <span className="oasisBrand__b2">Markets</span>
                  </span>
                </Link>
                <NavLink onClick={onclick} to="/portfolio" className="nav-link">
                  Portfolio
                </NavLink>
                <NavLink onClick={onclick} to={`/trade?symbol=${selectedPair?.pair_key}`} className="nav-link">
                  Trade
                </NavLink>
                <Dropdown className="navDropdown" align="start">
                  <Dropdown.Toggle variant="" id="dropdown-basic">
                    Market <DownArrowIcon />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Link onClick={() => onSelectSctions("BuySellTab")} to="javascript:void(0)">
                      Place Order
                    </Link>
                    <Link onClick={() => onSelectSctions("Accounts")} to="javascript:void(0)">
                      Accounts
                    </Link>
                    <Link onClick={() => onSelectSctions("OrderBook")} to="javascript:void(0)">
                      Orderbook
                    </Link>
                    <Link onClick={() => onSelectSctions("TradeChart")} to="javascript:void(0)">
                      Charts
                    </Link>
                    <Link onClick={() => onSelectSctions("OpenOrder")} to="javascript:void(0)">
                      Orders
                    </Link>
                    <Link onClick={() => onSelectSctions("WatchList")} to="javascript:void(0)">
                      Watch List
                    </Link>
                    <Link onClick={() => onSelectSctions("MarketTrades")} to="javascript:void(0)">
                      Market Trades
                    </Link>
                    <p>
                      Click on or Drag an item and Drop it to a place into the
                      layout
                    </p>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="headerFunds d-xl-flex align-center">
                <ul className="d-xl-flex">
                  <li>
                    <h6>Base Currency</h6>
                    <h6>
                      USD
                      {/* {selectedPair ? selectedPair.pair_key.split('_')[1].toUpperCase() : ''} */}
                    </h6>
                  </li>
                  <li>
                    <h6>Total Balance</h6>
                    <h6 className="green_text">
                      $
                      {activePairBalance ? toFix(activePairBalance?.totalUsdBalance, 2) : 0}
                    </h6>
                  </li>
                  <li>
                    <h6>Available Funds</h6>
                    <h6 className="green_text">
                      $
                      {activePairBalance ? toFix(activePairBalance?.availableUsdBalance, 2) : 0}
                    </h6>
                  </li>
                </ul>
                <div className="coinDropdown">
                  <Dropdown className="assetDropdown" align="end" popperConfig={{
                  modifiers: [{
                    name: "offset",
                    options: {
                      offset: [0, 8]
                    }
                  }, {
                    name: "assetMenuSameWidth",
                    enabled: true,
                    phase: "beforeWrite",
                    requires: ["computeStyles"],
                    fn: ({
                      state
                    }) => {
                      state.styles.popper.width = `${state.rects.reference.width}px`;
                    }
                  }]
                }}>
                    <Dropdown.Toggle variant="" id="asset-type-dropdown">
                      {selectedAssetType.label} <DownArrowIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {assetTypeDropdownOptions.map(option => <Dropdown.Item key={option.value} as="button" type="button" className={selectedAssetType.value === option.value ? "is-selected" : ""} onClick={e => {
                      handleAssetTypeChange(option);
                      e.currentTarget.blur();
                    }}>
                          {option.label}
                        </Dropdown.Item>)}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </Navbar.Collapse>
            {isActive && <div onClick={onclick} className={`${isActive ? "active" : ""} sidebar_backdrop d-xl-none`} />}

            <div className="rightHeader d-flex align-items-center justify-content-between">
              <div className="userDropdown">
                <NotificationList />
              </div>
              <div className="NotificationDropdown">
                <Dropdown align="end">
                  <Dropdown.Toggle variant="" id="dropdown-basic">
                    <UserIcon />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {/* <Dropdown.Item onClick={onclick}>
                      <span>
                        <WalletIcon />
                      </span>{" "}
                      Connect Wallet
                     </Dropdown.Item> */}
                    <Dropdown.Item as="button" type="button" onClick={openUserProfile} className="headerUserMenuItem">
                      <span>
                        <UserIcon />
                      </span>
                      Profile
                    </Dropdown.Item>
                    <NavLink className="dropdown-item headerUserMenuItem" to="/setting" onClick={onclick}>
                      <span>
                        <SettingIcon />
                      </span>
                      Settings
                    </NavLink>
                    <Dropdown.Item as="button" type="button" onClick={logout} className="headerUserMenuItem">
                      <span>
                        <UnlockIcon />
                      </span>
                      Logout
                    </Dropdown.Item>
                    <Dropdown.Item as="button" type="button" disabled={current_breakpoint === "sm" || current_breakpoint === "xs"} onClick={hanldeResetLayout} className="headerUserMenuItem">
                      <span aria-hidden="true">
                        <ResetLayoutIcon />
                      </span>
                      Reset Layout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <ThemePalette />
              <Navbar.Toggle ref={ref} onClick={toggleClass} />
            </div>
          </Container>
        </Navbar>
      </header>
      <UserProfileModal show={profileModalOpen} onHide={() => setProfileModalOpen(false)} userInfo={userInfo} />
    </>;
};
export default Header;